import GoogleAds from "../../../../contents/docs/cdp/sources/_snippets/source-google-ads.mdx";
import * as React from 'react';
export default {
  GoogleAds,
  React
};